import { render } from "./MetadataVariableUniverse.vue?vue&type=template&id=6cc8ab88"
import script from "./MetadataVariableUniverse.vue?vue&type=script&lang=js"
export * from "./MetadataVariableUniverse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__